export default __webpack_public_path__ + "static/media/withdraw-ecredit-step4-option1.cb564d6f.png";